import { Api } from "./datasources/Api";
import { setupAuthInterceptor } from "./interceptors/auth.interceptor";

const api = new Api({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8005",
});

setupAuthInterceptor(api.instance);

export { api };
